<div id="cac-identification-div" class="divWhiteBackground" *ngIf="globalText">
  <form
    id="cac-identification-details-form"
    class="formStyle"
    [formGroup]="identificationForm"
  >
    <div class="form-group">
      <h2 class="dark-blue bold center">
        {{ globalText?.identification?.title }}
      </h2>

      <div class="dark-blue-80 center" id="cac-identification-estd-span">
        {{ globalText?.identification?.subTitle }}
      </div>
    </div>
    <div class="form-group pt-40"></div>
    <div class="form-group">
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-identification-div-error-ssn"
          [ngClass]="
            f.ssn.touched && f.ssn.errors ? 'has-error' : 'mobileView-pb-15'
          "
          class="form-group mobileView-pb-15"
        >
          <p
            id="cac-identification-label-ssn"
            htmlFor="cac-identification-label-ssn"
            class="dark-blue control-label"
            [class.validation-error]="
              (f.ssn.touched && f.ssn.errors) || ssnInvalidErrMessage
            "
            class="ssnInvalidErrMessage"
          >
            <span>{{
              globalText?.identification?.formsFields?.ssn?.label1
            }}</span>
            <span>{{
              globalText?.identification?.formsFields?.ssn?.label2
            }}</span>
          </p>
          <input
            id="cac-identification-ssn"
            name="ssn"
            type="password"
            inputmode="numeric"
            formControlName="ssn"
            mask="000-00-0000"
            [validation]="false"
            [dropSpecialCharacters]="false"
            (keydown)="showFormErrorMessages = false; (true)"
            (blur)="showFormErrorMessages = true"
            aria-labelledby="cac-identification-label-ssn"
            maxLength="11"
            class="form-control col-left ssn4mt fs-mask identity-ssn-masked"
            [ngClass]="ssnInvalidErrMessage ? 'hasssnerr' : ''"
            (keyup)="disableSsnMessage()"
          />
          <span
            tabindex="0"
            id="toggleEye"
            class="fa"
            appPassword
            [ngClass]="ssnInvalidErrMessage ? 'ssncolor' : ''"
          ></span>
          <span
            *ngIf="(f.ssn.touched && f.ssn.errors) || ssnInvalidErrMessage"
            class="validation-error-icon-ssn validation-error-icon"
            ><img
              [ngClass]="ssnInvalidErrMessage ? 'ssncolor' : ''"
              class="error-icn"
              src="{{ exclamation }}"
              alt="err"
            />
          </span>
        </div>
        <div class="form-group custom-display-inline">
          <div
            *ngIf="
              ssnControl.touched && !ssnControl.valid && showFormErrorMessages
            "
            role="alert"
            aria-atomic="true"
            class="required validation-error"
          >
            {{ (ssnControl.errors ?? {} | keyvalue)[0].value }}
          </div>
          <div
            role="alert"
            aria-atomic="true"
            class="required validation-error"
            *ngIf="ssnInvalidErrMessage"
          >
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group desktop-97-5">
      <div
        id="cac-div-ssn-termsAndConditions"
        class="legalText cac-osm-identity-consent"
      >
        <label
          id="termsAndConditions"
          class="legalTextInner Visby-Medium"
          [innerHTML]="consentCreditAuth | safeHtml"
        ></label>

        <div class="identity-consent-agree-label">
          <div class="cac-agreement-consent">
            <input
              type="checkbox"
              formControlName="agreement_consent"
              aria-labelledby="termsAndConditions"
              id="agreement_consent"
              name="agreement_consent"
            />
          </div>
          <div class="identity-consent-agree-label-txt Acceptance-Bold">
            I Agree
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
